<template>
    <div class="page" id="txr">
       <div class="title flex_h_hS_vC">
          <span class="text">网点商户管理</span>
           <div class="head-bnt flex_h_hR_vC">
              <div class="add-website flex_h_hC_vC" @click="addBaseAgentMember">
                 <img src="../../../assets/images/recordInformatica/addwebsite.png">
                  <span class="add-text">添加网点商户</span>
              </div>
               <div class="export flex_h_hC_vC" @click="exportMember">
                   <img src="../../../assets/images/recordInformatica/export.png">
                   <span class="export-text">批量导入</span>
               </div>
           </div>
       </div>
       <div class="filter-box flex_h_hS_vC">
           <div class="">
               <input v-model="searchForm.name" class="filter-input" placeholder="输入商户名称" >
               <input  v-model="searchForm.code" class="filter-input" placeholder="输入商户账号">
               <el-select v-model="searchForm.status" placeholder="全部状态" size="small">
                 <el-option v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">

                 </el-option>
               </el-select>
           </div >
            <div class="searchOrReset flex_h_hR_vC">
                <el-button class="btn-search" @click="search" size="medium" title="搜索"><i class="el-icon-search"> 搜索</i></el-button>
                <el-button class="btn-reset" @click="reset" size="medium" title="重置"><i class="el-icon-refresh"> 重置</i></el-button>
            </div>
        </div>
       <div class="select-tab flex_h_hL_vC">
           <div style="width: 19px"></div>
           <div  v-for="(item, index) in tabType" :key="index"  @click="selectTab(index)">
               <div :class="{'actived': showActie(index)}" class="tab-text" v-text="item.laber"/>
           </div>

       </div>
       <div class="table-box">
           <div class="table-box-title flex_h_hL_vC">
               <span class="title">网点商户列表</span>
           </div>
           <div class="table-box-el">
               <el-table :data="tableData" style="width: 100%;"  :header-cell-style="tableHeaderColor"
                         border fit highlight-current-row tooltip-effect="dark">
                   <el-table-column type="selection" width="28px">
                   </el-table-column>
                   <el-table-column :label="changeColumn(idx,'name')" prop="name" min-width="17%" header-align="center" align="center"
                                    show-overflow-tooltip></el-table-column>
                   <el-table-column :label="changeColumn(idx,'code')" prop="code"  min-width="17%" header-align="center"
                                    align="center">
                   </el-table-column>
                   <el-table-column :label="changeColumn(idx,'child')" prop="childCount"  min-width="16%" header-align="center" align="center"
                                    show-overflow-tooltip>
                       <template slot-scope="scope">
                          <span class="table-row-childCount" v-if="searchForm.type !=3">
                                  {{scope.row.childCount}}
                          </span>
                           <span class="table-row-childCount" v-if="searchForm.type ==3">
                                  {{scope.row.parantName}}
                          </span>
                       </template>
                   </el-table-column>
                   <el-table-column label="账户信息" prop="accountIsHas"  min-width="12%" header-align="center" align="center">
                       <template slot-scope="scope">
                          <span class="table-row-orange" v-if="scope.row.accountIsHas !='有'">
                                  {{scope.row.accountIsHas}}
                          </span>
                           <span class="table-row-green" v-if="scope.row.accountIsHas =='有'">
                                  {{scope.row.accountIsHas}}
                          </span>
                       </template>
                   </el-table-column>
                   <el-table-column label="实名信息" prop="realNameIsHas"  min-width="12%" header-align="center" align="center"
                                    show-overflow-tooltip>
                       <template slot-scope="scope">
                          <span class="table-row-orange" v-if="scope.row.realNameIsHas !='已实名' ">
                                  {{scope.row.realNameIsHas}}
                          </span>
                           <span class="table-row-green" v-if="scope.row.realNameIsHas =='已实名'">
                                  {{scope.row.realNameIsHas}}
                          </span>
                       </template>
                   </el-table-column>
                   <el-table-column label="商户状态" prop="statusName"  min-width="12%" header-align="center" align="center">
                       <template slot-scope="scope">
                          <span class="table-row-orange" v-if="scope.row.statusName !='正常'">
                                  {{scope.row.statusName}}
                          </span>
                           <span class="table-row-green" v-if="scope.row.statusName =='正常'">
                                  {{scope.row.statusName}}
                          </span>
                       </template>
                   </el-table-column>
                   <el-table-column label="操作" fixed="right"  width="244px" header-align="center" align="center"
                                    show-overflow-tooltip>
                       <template slot-scope="scope">
                           <div class="flex_h_hC_vC">
                               <div @click="lookBaseAgentMember(scope.row.id)">
                                   <img style="width: 10px;height: 10px;" src="../../../assets/images/recordInformatica/detail.png">
                                   <span class="table-operation-green">详情</span>
                               </div>
                               <div style="margin-left:15px" @click="editBaseAgentMember(scope.row.id)">
                                   <img style="width: 10px;height: 10px;" src="../../../assets/images/recordInformatica/edit.png">
                                   <span class="table-operation-green">编辑</span>
                               </div>
                               <div style="margin-left:15px" @click="showConfirmToast(scope.row.id,'enable')" v-if="scope.row.status ==0">
                                   <img style="width: 10px;height: 10px;" src="../../../assets/images/recordInformatica/enable.png">
                                   <span class="table-operation-green">启用</span>
                               </div>
                               <div style="margin-left:15px" @click="showConfirmToast(scope.row.id,'disable')" v-if="scope.row.status ==1">
                                   <img style="width: 10px;height: 10px;" src="../../../assets/images/recordInformatica/disable.png">
                                   <span class="table-operation-orange">禁用</span>
                               </div>
                               <div style="margin-left:15px" @click="showConfirmToast(scope.row.id,'delete')" v-if="scope.row.status ==0">
                                   <img style="width: 10px;height: 10px;" src="../../../assets/images/recordInformatica/delete.png">
                                   <span class="table-operation-orange">删除</span>
                               </div>
                           </div>
                       </template>
                   </el-table-column>
               </el-table>
               <div class="pageBox boxs">
                   <el-pagination @size-change="handleSizeChange"
                                  @current-change="handleCurrentChange"
                                  :current-page="searchForm.page"
                                  :page-sizes="[10, 20, 30]"
                                  :page-size="searchForm.pageSize"
                                  layout="total, sizes, prev, pager, next, jumper" :total="total">
                   </el-pagination>
               </div>
           </div>
       </div>

        <baseDialog
                :title="dialogTitle"
                :zIndex="1000"
                :visible.sync="IsAddDlg"
                :isFooter="isFooter"
                :modal="modal"
                :close-on-click-modal="false"
                @confirmEmit="confirmEmit"
                @closeEmit="closeEmit"
                width="341px">
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>商户类型:</label>
                <el-select style="height: 32px; width:220px" v-model="baseAgentMember.type" placeholder="请选择商户类型" size="small">
                    <el-option v-for="item in tabType"
                               :key="item.value"
                               :label="item.laber"
                               :value="item.value">

                    </el-option>
                </el-select>
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b v-if="baseAgentMember.type ==3">*</b>上级代理商:</label>
                <el-select style="height: 32px; width:220px" v-model="baseAgentMember.parentId" placeholder="请选择上级代理商" size="small">
                    <el-option v-for="item in higeLevel"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>商户名称:</label>
                <input v-model.trim="baseAgentMember.name" maxLength="20" type="text" class="flex_1" placeholder="请输入商户名称">
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>商户账号:</label>
                <input v-model.trim="baseAgentMember.code" maxLength="20" type="text" class="flex_1" placeholder="请输入商户账号">
            </div>
            <div class="dialog-littleTitle flex_h_hL_vC">
                <div class="dialog-littleTitle-image"></div>
                <span class="dialog-littleTitle-text">账号信息</span>
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>账号类型:</label>
                <el-select style="height: 32px; width:220px" v-model="baseAgentMember.bankType" placeholder="请选择账户类型" size="small">
                    <el-option v-for="item in bankType"
                               :key="item.codeNum"
                               :label="item.name"
                               :value="item.codeNum">
                    </el-option>
                </el-select>
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>账户号:</label>
                <input v-model.trim="baseAgentMember.bankAccountNum" maxLength="20" type="text" class="flex_1" placeholder="请输入账户号/银行卡号">
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>账号姓名:</label>
                <input v-model.trim="baseAgentMember.bankAccountName" maxLength="20" type="text" class="flex_1" placeholder="请输入账户绑定的用户姓名">
            </div>
            <div class="dialog-littleTitle flex_h_hL_vC">
                <div class="dialog-littleTitle-image"></div>
                <span class="dialog-littleTitle-text">实名信息</span>
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>姓名:</label>
                <input v-model.trim="baseAgentMember.fullName" maxLength="20" type="text" class="flex_1" placeholder="请输入姓名">
            </div>
            <div  class="dialog-input flex_h_hL_vC">
                <label class="flex_h_hL_vC"><b>*</b>身份证号码:</label>
                <input v-model.trim="baseAgentMember.idCard" maxLength="20" type="text" class="flex_1" placeholder="请输入身份证号码">
            </div>
            <div class="idcard flex_h_hC_vC">
                <div class="idcardUpload flex_v_hC_vC">
                       <div class="idcard-upload-image">
                           <el-upload
                                   class="avatar-uploader"
                                   action=""
                                   :show-file-list="false"
                                   :before-upload="beforeUpload"
                                   :on-success="handleUploadFrontSuccess"
                                   :on-error="handleUploadFrontError"
                                   :http-request="onUploadFront">
                               <template>
                                   <img class="idcard-upload-image" v-if="baseAgentMember.idCardFront !=''" :src="$variable.getFile(baseAgentMember.idCardFront)">
                                   <img v-if="baseAgentMember.idCardFront ==''" src="../../../assets/images/recordInformatica/idCardFront.png">
                               </template>
                           </el-upload>
                       </div>
                    <span class="idcard-text">点击上传身份证人像面</span>
                </div>
                <div class="idcardUpload flex_v_hC_vC" style="margin-left: 3px">
                    <div >
                        <el-upload
                                class="avatar-uploader"
                                action=""
                                :show-file-list="false"
                                :before-upload="beforeUpload"
                                :on-success="handleUploadBackSuccess"
                                :on-error="handleUploadBackError"
                                :http-request="onUploadBack">
                            <template>
                                <img class="idcard-upload-image"  v-if="baseAgentMember.idCardBack !=''" :src="$variable.getFile(baseAgentMember.idCardBack)">
                                <img v-if="baseAgentMember.idCardBack ==''" src="../../../assets/images/recordInformatica/idCardAfter.png">
                            </template>
                        </el-upload>
                    </div>
                    <span class="idcard-text">点击上传身份证国徽面</span>
                </div>
            </div>
        </baseDialog>
        <base-message-box
                :title="confirmTitle"
                :content="confirmContont"
                @cancel="handleCancel()"
                @confirm="handleConfirm()"
                :visible.sync="showConfirm">
        </base-message-box>

        <baseDialog :visible.sync="importVisible" title="导入" :close-on-click-modal="false" :zIndex="1000" :modal="false" width="440px"
                    @closeEmit="closeExportEmit">
            <div class="dialog-upload flex_h_hL_vC">
                <div class="input-btn flex_h_hC_vC">
                    <img src="../../../assets/images/recordInformatica/uploadIcon.png"/>
                    <span>上传文件</span>
                    <input @change="uploadFileEvent($event)" ref="uploadFile" style="cursor: pointer" type="file"
                           accept=".xls,.xlsx" title="点击上传">
                </div>
                <span v-if="!file.name">
                    请 <span class="color-green" style="cursor: pointer" @click="downloadModel">下载模板</span> 按照模板编辑上传文件
                </span>
                <span v-if="file.name" class="flex_h_hL_vC">
                    <span class="color-green">{{file.name}}</span>
                    <img @click="deleteFile" class="del-icon"
                         src="../../../assets/images/recordInformatica/delIcon.png"/>
                </span>
            </div>
            <div class="dialog-footer flex_h_hC_vC">
                <div @click="closeExportEmit"  class="dialog-btn ope-btn-transparent flex_h_hC_vC">取消</div>
                <div @click="importConfirmEvent" class="dialog-btn flex_h_hC_vC">确定</div>
            </div>
        </baseDialog>
    </div>
</template>

<script>
    import {getAllBaseAgentMemberInfo,getBaseAgentMemberInfo,insertOrUpdateBaseAgentMember,
        disableMember,enableMember,deleteMember,getHigeAgentMember,getBankType,exportAgentMember} from '@/api/Tbs/RecordInformatica/recordInformatica.js';
    import {delFile, uploadFile} from '@/api/common.js';
    import  baseDialog  from '@/components/Common/BaseDialog/code/baseDialog';
    import  baseMessageBox from  '@/components/Common/BaseConfirmBox/BaseConfirmBox';
    export default {
        name: "websiteAndMerchants",
        data(){
            return{
                tabType:[{
                        laber:'终端商',
                        value: 1,
                       },{
                        laber:'营业厅',
                        value:2,
                         },
                    {
                        laber: '揽装员',
                        value: 3,
                    }],
                options:[{
                        label: '正常',
                        value: 1
                    },
                    {
                        label:'禁用',
                        value:0
                    }],
                tableData:[
                    {
                      name:'正常',
                      code:'正常',
                      childCount:'2',
                      accountIsHas:'有',
                      realNameIsHas:'待实名',
                      statusName:'正常',
                    }
                ],
                higeLevel:[
                    {
                        id:1,
                        name:'代理商'
                    },
                    {
                        id:2,
                        name:'终端商'
                    }
                ],
                bankType:[
                    {
                        id:1,
                        name:'建行卡'
                    },
                    {
                        id:2,
                        name:'招商卡'
                    }
                ],
                idx:0,
                total:0,
                searchForm:{
                    name:'',
                    code:'',
                    status:null,
                    page:1,
                    pageSize:10,
                    type:1,
                },
                dialogTitle:'添加网点商户',
                // 弹窗
                modal: false,
                IsAddDlg: false,
                isFooter:true,
                baseAgentMember:{
                    id:'',
                    code:'',
                    name:'',
                    type:'',
                    parentId:'',
                    bankType:'',
                    bankAccountNum:'',
                    bankAccountName:'',
                    fullName:'',
                    idCard:'',
                    idCardFront:'',
                    idCardBack:''
                },
                //确认框
                confirmTitle:'',
                confirmContont:'',
                showConfirm:false,
                confirmId :'',
                confirmOption :'',
                picUploadParams: {
                    busiId: 'Product',
                    busiType: 'Product'
                },
                importVisible:false,
                file: {
                    target: null,
                    name: ''
                },
            }
        },
        components: {
            baseDialog,
            baseMessageBox,
        },
        mounted(){
          this.gotoPage(1)
          this.getBankType()
        },
        methods:{
            tableHeaderColor({row, column, rowIndex, columnIndex}){
               return 'height:29px;background:rgba(245,245,245,1);border:1px solid rgba(238,238,238,1);opacity:1;'
            },
            search(){
                this.gotoPage(1)
            },
            reset(){
                this.searchForm.name =''
                this.searchForm.code =''
                this.searchForm.status =null
                this.searchForm.page =1
            },
            addBaseAgentMember(){
                this.IsAddDlg =true
                this.dialogTitle = '新增网点商户'
                this.getHigeAgentMember()
            },
            editBaseAgentMember(id){
                this.getBaseAgentMemberInfo(id)
                this.getHigeAgentMember()
                this.dialogTitle = '编辑网点商户'
                this.IsAddDlg =true
            },
            lookBaseAgentMember(id){
                this.getBaseAgentMemberInfo(id)
                this.getHigeAgentMember()
                this.isFooter =false
                this.dialogTitle = '查看网点商户'
                this.IsAddDlg =true
            },
            selectTab(index){
                this.idx =index;
               this.searchForm.type =  this.tabType[index].value
                this.gotoPage(1)
            },
            showActie(index){
                return this.idx === index;
            },
            //改变列名
            changeColumn(idx,name){
                if (idx === 0){
                    if (name =='name'){
                        return '商户名称'
                    }
                    if (name =='code'){
                        return '商户账号'
                    }
                    if (name =='child'){
                        return '下级个体网点'
                    }
                }
                if(idx === 1){
                    if (name =='name'){
                        return '终端商名称'
                    }
                    if (name =='code'){
                        return '终端商账号'
                    }
                    if (name =='child'){
                        return '下级个体网点'
                    }
                }
                if(idx === 2){
                    if (name =='name'){
                        return '揽件员名称'
                    }
                    if (name =='code'){
                        return '揽件员账号'
                    }
                    if (name =='child'){
                        return '上级代理商'
                    }
                }
            },

            //页脚操作
            handleSizeChange(value){
              this.searchForm.pageSize =value
              this.gotoPage(1)
            },
            handleCurrentChange(value){
                this.searchForm.page =value
                this.gotoPage(value)
            },

            closeEmit(){
                for (let key of Object.keys(this.baseAgentMember)){
                   this.baseAgentMember[key] = ''
                }
                this.IsAddDlg =false
                this.isFooter =true
            },
            confirmEmit(){
                this.valation();
            },
            //获取列表数据
            gotoPage(page){
                this.searchForm.page =page
                getAllBaseAgentMemberInfo(this.searchForm).then(res =>{
                    if(res.code !=0){
                        return
                    }
                   this.tableData = res.data.records;
                   this.total = res.data.total;

                }).catch(error =>{
                    console.log(error)
                })
            },

            getBaseAgentMemberInfo(id){
                getBaseAgentMemberInfo(id).then(res =>{
                    if (res.code !=0){
                        return this.$msgError(res.message)
                    }
                    Object.assign(this.baseAgentMember,res.data);
                }).catch(error =>{
                    console.log(error)
                })
            },
            insertOrUpdateBaseAgentMember(){
                insertOrUpdateBaseAgentMember(this.baseAgentMember).then(res =>{
                    if (res.code !=0){
                        return this.$msgError(res.message)
                    }
                    if ( this.baseAgentMember.id &&  this.baseAgentMember.id !=''){
                        this.$msgSuccess("修改网点商户成功")
                    } else {
                        this.$msgSuccess("新增网点商户成功")
                    }
                    this.IsAddDlg =false;
                    this.gotoPage(1)
                    return
                }).catch(error =>{
                    console.log(error)
                })
            },

            //显示确认框
            showConfirmToast(id,option){

                if (option ==='enable'){
                    this.confirmTitle ='启用'
                    this.confirmContont ='您确定要启用该网点商户账号吗？'
                }
                if (option ==='disable'){
                    this.confirmTitle ='禁用'
                    this.confirmContont ='您确定要禁用该网点商户账号吗？'
                }
                if (option ==='delete'){
                    this.confirmTitle ='删除'
                    this.confirmContont ='您确定要删除该网点商户账号吗？'
                }
                this.confirmId =id
                this.confirmOption =option
                this.showConfirm =true
            },
            handleCancel(){
                this.confirmId =''
                this.confirmOption =''
                this.showConfirm =false
                return
            },
            handleConfirm(){
                if (this.confirmOption && this.confirmOption !=''){
                    if (this.confirmOption == 'enable'){
                        this.enableMember(this.confirmId)
                    }
                    if (this.confirmOption == 'disable'){
                        this.disableMember(this.confirmId)
                    }
                    if (this.confirmOption == 'delete'){
                        this.deleteMember(this.confirmId)
                    }

                }

            },
            disableMember(id){
                disableMember(id).then(res =>{
                    if (res.code !=0){
                        this.$msgError("禁用失败")
                    }
                    this.$msgSuccess("禁用成功")
                    this.showConfirm =false
                    this.gotoPage(1)
                    return
                }).catch(error =>{
                    console.log(error)
                })
            },
            enableMember(id){
                enableMember(id).then(res =>{
                    if (res.code !=0){
                        this.$msgError("启用失败")
                    }
                    this.$msgSuccess("启用成功")
                    this.showConfirm =false
                    this.gotoPage(1)
                    return
                }).catch(error =>{
                    console.log(error)
                })
            },

            deleteMember(id){
                deleteMember(id).then(res =>{
                    if (res.code !=0){
                        this.$msgError("删除失败")
                    }
                    this.$msgSuccess("删除成功")
                    this.showConfirm =false
                    this.gotoPage(1)
                    return
                }).catch(error =>{
                    console.log(error)
                })
            },

            getHigeAgentMember(){
                getHigeAgentMember().then(res =>{
                    if (res.code !=0){
                        return this.$msgError(res.message)
                    }
                    this.higeLevel = res.data;
                }).catch(error =>{
                    console.log(error)
                })
            },
            getBankType(){
                getBankType().then(res =>{
                    if (res.code !=0){
                        return this.$msgError(res.message)
                    }
                    this.bankType = res.data;
                }).catch(error =>{
                    console.log(error)
                })
            },

            beforeUpload(file){
                const isJPEG = file.type === 'image/jpeg';
                const isJPG = file.type === 'image/jpg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG && !isJPEG) {
                    this.$message.error('只能上传jpg/png文件!');
                    return;
                }
                return true;
            },
            // 文件上传成功时的钩子
            handleUploadFrontSuccess(res, file) {
               const url= URL.createObjectURL(file.raw);
               console.log('urlfront',url)
               this.idcardFrontUrl = url;
            },
            handleUploadBackSuccess(res, file) {
                const url= URL.createObjectURL(file.raw);
                console.log('urlafter',url)
                this.idcardBackUrl = url
            },
            // 文件上传失败时的钩子
            handleUploadFrontError(res, file) {
                this.$message.error('凭证身份证人像面失败！')
            },
            handleUploadBackError(res, file) {
                this.$message.error('凭证身份证头徽像失败！')
            },

            onUploadFront(uploadObj) {
                let file = uploadObj.file
                let param = new FormData()
                param.append('file', file)
                uploadFile(param)
                    .then(resp => {
                       // uploadObj.onSuccess(resp)
                        let uploadedFile = resp.data.uploadedFiles[0];
                        this.baseAgentMember.idCardFront = uploadedFile.id
                    }).catch(e => {
                    //uploadObj.onError(e)
                    console.log(e)
                })
            },
            onUploadBack(uploadObj) {
                let file = uploadObj.file
                let param = new FormData()
                param.append('file', file)
                uploadFile(param)
                    .then(resp => {
                       // uploadObj.onSuccess(resp)
                        let uploadedFile = resp.data.uploadedFiles[0];
                        this.baseAgentMember.idCardBack = uploadedFile.id
                    }).catch(e =>{
                    //uploadObj.onError(e)
                    console.log(e)
                })
            },
            exportMember(){
                this.$message({
                    message: '该功能尚未开放！',
                    type: 'warning'
                });
            },
            showExport(){
                this.$refs.uploadFile.value = null;
                this.importVisible = true;
            },

            valation(){
                let idcardReg =/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
                let bankCardReg = /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/

                if(!this.baseAgentMember.type || this.baseAgentMember.type ==''){
                    return this.$msgError("商户类型必填！")
                }
                if(this.baseAgentMember.type ==3){
                    if (!this.baseAgentMember.parentId || this.baseAgentMember.parentId ==''){
                        return this.$msgError("请选择上级代理商！")
                    }
                }
                if(!this.baseAgentMember.name || this.baseAgentMember.name ==''){
                    return this.$msgError("商户名称必填！")
                }
                if(!this.baseAgentMember.code || this.baseAgentMember.code ==''){
                    return this.$msgError("商户账号必填！")
                }
                if(!this.baseAgentMember.bankType|| this.baseAgentMember.bankType ==''){
                    return this.$msgError("账户类型必填！")
                }
                if(!this.baseAgentMember.bankAccountNum || this.baseAgentMember.bankAccountNum ==''){
                    return this.$msgError("账户号必填！")
                }
                if (!bankCardReg.test(this.baseAgentMember.bankAccountNum)){
                    return this.$msgError("请输入正确格式的银行卡号")
                }
                if(!this.baseAgentMember.bankAccountName || this.baseAgentMember.bankAccountName ==''){
                    return this.$msgError("账户姓名必填！")
                }
                if(!this.baseAgentMember.fullName || this.baseAgentMember.fullName ==''){
                    return this.$msgError("姓名不必填！")
                }
                if(!this.baseAgentMember.idCard || this.baseAgentMember.idCard ==''){
                    return this.$msgError("身份证号码必填！")
                }
                if(!idcardReg.test(this.baseAgentMember.idCard)){
                    return this.$msgError("请输入正确的身份证号码")
                }
                if(!this.baseAgentMember.idCardFront || this.baseAgentMember.idCardFront ==''){
                    return this.$msgError("请上传身份证人脸图！")
                }

                if(!this.baseAgentMember.idCardBack || this.baseAgentMember.idCardBack ==''){
                    return this.$msgError("请上传身份证国徽图！")
                }

                this.insertOrUpdateBaseAgentMember();
            },

            // 文件操作
            uploadFileEvent(e) { // 文件上传
                let file = e.target.files[0];
                if (!file) return;
                let fileSize = file.size;
                let fileType = file.type;
                let fileName = file.name;
                this.file.target = file;
                this.file.name = fileName;
            },
            deleteFile() { // 删除文件
                this.file.target =null
                this.file.name =''
                this.$refs.uploadFile.value = null;
            },
            downloadModel() {
                /*downloadModelAPI().then(res => {
                    this.YD_exportFile(res, '人员导入模板.xlsx');
                });*/
            },
            importConfirmEvent(){
                if (!this.file.target || this.file.target == null || this.file.name ==''){
                   return  this.$msgError("请先上传文件")
                }
                let params = new FormData();
                params.append('file', this.file.target);
                exportAgentMember(params).then(res => {
                    this.$msgSuccess('批量导入网点商户成功');
                    this.$refs.uploadFile.value = null;
                    this.importVisible = false
                })
            },
            closeExportEmit(){
                this.file.name ='',
                this.file.target =null
                this.importVisible = false
            }
        }
    }
</script>

<style scoped>
    .page{
        padding: 0px 4px 8px 4px;
    }
    .title{
        height:44px;
        background:rgba(251,251,251,1);
        opacity:1;
    }
    .title .text{
        margin-left: 12px;
        width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:17px;
        color:rgba(43,39,39,1);
        opacity:1;
        text-align: center;
    }
    .title .head-bnt{
        margin-right: 12px;
    }
    .title .add-website{
        margin-right: 10px;
        width:120px;
        height:30px;
        background:rgba(45,186,165,1);
        opacity:1;
        border-radius:4px;
    }
    .title .export{
        width:95px;
        height:30px;
        background:rgba(250,98,65,1);
        opacity:1;
        border-radius:4px;
    }
    .title .add-text{
        margin-left: 5px;
        width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(255,255,255,1);
        opacity:1;
    }
    .title .export-text{
        margin-left: 5px;
        width:60px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(255,255,255,1);
        opacity:1;
    }
    .filter-box{
        padding-left: 12px;
        height:60px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .filter-box .filter-input{
        width:200px;
        height:36px;
        margin-right: 12px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(238,238,238,1);
        opacity:1;
        border-radius:3px;
        padding-left: 10px;
    }
    input::placeholder{
        width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(209,209,209,1);
        opacity:1;
    }
    .searchOrReset{
        margin-right: 12px;
    }

    .select-tab{
        margin-top: 14px;
        height:44px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .select-tab .tab-text{
         margin-right: 45px;
         width:39px;
         height:17px;
         font-size:13px;
         font-family:Microsoft YaHei;
         font-weight:400;
         line-height:17px;
         color:rgba(51,51,51,1);
         opacity:1;
     }
    .select-tab .tab-text.actived{
        border-bottom: 3px solid rgba(250,98,65,1);
        color: rgba(250,98,65,1);
        font-weight: bold;
    }
    .table-box{
        margin-top: 14px;
    }
    .table-box-title {
        width: 100%;
        height:44px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .table-box-title .title{
        margin-left: 12px;
        width:90px;
        height:20px;
        font-size:15px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:20px;
        color:rgba(43,39,39,1);
        opacity:1;
    }
    .table-row-green{
        width:12px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(118,200,25,1);
        opacity:1;
    }
    .table-row-childCount{
        width:7px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(45,186,165,1);
        opacity:1;
    }
    .table-row-orange{
        width:36px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(250,98,65,1);
        opacity:1;
    }

    .table-operation-green{
        width:24px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:14px;
        color:rgba(45,186,165,1);
        opacity:1;
    }
    .table-operation-orange{
        width:24px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:14px;
        color:rgba(250,98,65,1);
        opacity:1;
    }
    .dialog-title{
        width: 100%;
        height:40px;
        background:#EEEEEE;
        border:1px solid rgba(238,238,238,1);
        opacity:1;
    }
    .dialog-title-text{
        width:72px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:16px;
        color:rgba(43,39,39,1);
        opacity:1;
    }
    .dialog-input{
        width: 100%;
        height: 36px;
        font-size: 13px;
        color: #2B2727;
        margin-bottom: 12px;
        border-radius: 5px;
        position: relative;
    }
    .dialog-littleTitle{
        margin-top: 6px;
        margin-bottom: 6px;
    }
    .dialog-littleTitle-text{
        width:57px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:16px;
        color:rgba(51,51,51,1);
        opacity:1
    }

    .dialog-littleTitle-image{
        height: 10px;
        width: 4px;
        background-color: rgba(250,98,65,1);
        margin-right: 4px;
    }
    .dialog-input label{
        display: block;
        width: 90px;
        font-size: 13px;
        color: #AAAAAA;
        font-weight: bold;
        position: relative;
        box-sizing: border-box;
        padding-left: 14px;
    }
    .dialog-input label b{
        color: #FA6241;
        position: absolute;
        top: 2px;
        left: 6px;
    }
    .dialog-input input{
        font-size: 13px;
        color: #333333;
        width: 220px;
        height: 32px;
        border: none;
        background: transparent;
        border: 1px solid #EEEEEE;
        padding-left: 10px;
    }
   .idcard-text{
       width:72px;
       height:30px;
       font-size:12px;
       font-family:Heiti SC;
       font-weight:300;
       line-height:15px;
       color:rgba(209,209,209,1);
       opacity:1;
   }
   .idcardUpload{
       width:146px;
       height:111px;
       background:rgba(255,255,255,1);
       border:1px dashed rgba(238,238,238,1);
       opacity:1;
       border-radius:5px;
   }
   .idcard-upload-image{
       width: 56px;
       height: 34px;
   }
    .idcard{
        margin-top: 10px;
    }


    /*w文件上传*/
    .dialog-upload {
        margin-top: 14px;
    }
    .dialog-upload .input-btn {
        width: 120px;
        height: 32px;
        background: rgba(250,98,65,1);
        margin-right: 12px;
        color: #fff;
        font-size: 13px;
        border-radius: 3px;
        position: relative;
    }
    .dialog-upload .input-btn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }
    .dialog-upload .input-btn input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
    .dialog-upload .del-icon {
        width: 16px;
        height: 16px;
        margin-left: 12px;
        cursor: pointer;
    }
    .color-green{
        color:rgba(250,98,65,1);
    }
    .dialog-footer {
        margin-top: 24px;
    }
    .dialog-footer .dialog-btn {
        min-width: 98px;
        width: 98px;
        height: 40px;
    }


    /* 分页条 */
    .pageBox {
        width: 100%;
        padding: 15px 0 10px;
        display: flex;
        justify-content: flex-end;
        background: #ffffff;
        border: 1px solid #E4E4E4;
        border-top: none;
    }
    #txr .el-button {
        height: 36px;
        width: 80px;
        border-radius: 4px;
        padding: 11px 15px;
        border: none;
    }
    .btn-search {
        background-color: #FA6241;
        color: #fff;
    }
    .btn-search:hover {
        background-color: rgb(247, 143, 120);
    }
    .btn-reset {
        background-color: #F99A1A;
        color: #fff;
    }
    .btn-reset:hover {
        background-color: rgb(248, 186, 105);
    }
</style>